import { config } from 'config'
import fetchWithToken from 'utils/fetchWithToken'
import { getJSONBodyOrNull } from 'utils/getJSONBodyOrNull'

interface FetchUcsParams {
  method?: string
  path: string
  body?: any
  headers?: HeadersInit
}

export class FetchUcsError extends Error {
  constructor(message: string, public statusCode: number, public errorCode?: string) {
    super(message)
  }
}

const getErrorCode = async (response: Response): Promise<string | undefined> => {
  const content = await getJSONBodyOrNull(response)
  // In most cases there's only 1 error in the errors array so we only handle the first one
  return content.errors?.[0].code
}

export const fetchUcs = async ({ method = 'GET', path, body, headers }: FetchUcsParams): Promise<any> => {
  const response: Response = await fetchWithToken({
    method,
    baseUrl: config.UNIFIED_COMMERCE_SERVICE_URL,
    path,
    handleUnauthorized: false,
    useV5: false,
    useVersion: '',
    options: {
      headers: {
        tenant: 'GTA-unified-admin',
        ...headers,
      },
      ...(body && { body: JSON.stringify(body) }),
    },
  })

  if (!response.ok) {
    const errorCode = await getErrorCode(response)

    console.error('Unified Commerce Service call unsuccessful.', response, errorCode)
    throw new FetchUcsError('Unified Commerce Service call unsuccessful.', response.status, errorCode)
  }

  return getJSONBodyOrNull(response)
}
